<template>
  <v-list>
    <!-- Calendar event (talk only). Not a POST type, so the parent handles it via eventSelected. -->
    <v-list-tile v-if="includeEvent" avatar @click="onEventClick">
      <v-list-tile-action class="c-menu-icon">
        <v-icon>mdi-calendar</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $T('attributes.event') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile avatar @click="onClick('NS')">
      <v-list-tile-action class="c-menu-icon">
        <v-icon>{{ $utils.postCodeToIcon('NS') }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $utils.postCodeToName('NS') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile avatar @click="onClick('FL')">
      <v-list-tile-action class="c-menu-icon">
        <v-icon>{{ $utils.postCodeToIcon('FL') }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $utils.postCodeToName('FL') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile avatar @click="onClick('SD')">
      <v-list-tile-action class="c-menu-icon">
        <v-icon>{{ $utils.postCodeToIcon('SD') }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $utils.postCodeToName('SD') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile avatar @click="onClick('EQ')">
      <v-list-tile-action class="c-menu-icon">
        <v-icon>{{ $utils.postCodeToIcon('EQ') }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $utils.postCodeToName('EQ') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile avatar @click="onClick('LF')">
      <v-list-tile-action class="c-menu-icon">
        <v-icon>{{ $utils.postCodeToIcon('LF') }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ $utils.postCodeToName('LF') }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import UTILS from '../../utils/utils';
import store from '../../store';

export default {
  props: ['initCid', 'initMembers', 'talkShare', 'includeEvent'],
  data: function() {
    return {};
  },
  methods: {
    onEventClick() {
      this.$emit('eventSelected');
      this.$emit('menuSelected', 'EVENT');
    },
    onClick(code) {
      // talkShare ({tid}) is carried through so EditPostDialogs can share the created post into the
      // talk (addMsgPost) after it is registered. It is null/undefined for the normal MAIL page.
      this.$store.commit('POST_EDIT_DIALOG_OPEN', {
        code,
        cid: this.initCid,
        members: this.initMembers,
        talkShare: this.talkShare,
      });
      this.$emit('menuSelected', code);
    },
  },
};
</script>

<style scoped>
.c-menu-icon {
  min-width: 43px;
}
.c-menu-icon i {
  font-size: 26px;
}
</style>
